import { ButtonType } from '../../modal/button.handler';
import { InitButton } from '../../modal/modal.button';
import { ModalHandler } from '../../modal/modal.handler';

export function ipErrorHandler(): ModalHandler {
   const handler: ModalHandler = new ModalHandler();
   handler.title = 'Error';
   handler.text = 'You cannot use MedTracS from this IP address.';
   [handler.buttons] = InitButton({ type: ButtonType.Ok, prefix: 'ip-error' }, 1);
   handler.keyboard = false;
   handler.ignoreBackdropClick = true;
   handler.closeButton = false;
   return handler;
}
